import type { Item } from './types';

export const getMatchingRoutes = (items: Item[]): string[] => {
  const matches: string[] = [];
  items
    .filter(i => !i.newTab)
    .forEach(i => {
      if (i.activeUrl) {
        if (Array.isArray(i.activeUrl)) {
          matches.push(...i.activeUrl);
        } else {
          matches.push(i.activeUrl);
        }
      } else {
        matches.push(i.url);
      }
    });
  return matches;
};
